const matricula_sem_reserva = {
  path: "/reservar_vaga_aluno",
  redirect: "/reservar_vaga_aluno",
  meta: {
    breadCrumb: "Atendimento ao Aluno - Matrícula sem reserva",
  },
  children: [
    {
      path: "/matricula_sem_reserva",
      name: "matricula_sem_reserva",
      component: () =>
        import(
          "@/views/ReservaDeVagas/MatriculaSemReserva/MatriculaSemReservaHome.vue"
        ),
    },
    {
      path: "/matricula_sem_reserva_novo/:id",
      name: "matricula_sem_reserva_novo",
      component: () =>
        import(
          "@/views/ReservaDeVagas/MatriculaSemReserva/MatriculaSemReservaCad.vue"
        ),
    },
  ],
};

export { matricula_sem_reserva };
